/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Radio as MantineRadio, type MantineTheme, createTheme } from '@mantine/core';

import { colorToken } from '@fai/design-tokens';

import * as classes from './radio.css';

export const radioTheme = createTheme({
  components: {
    Radio: MantineRadio.extend({
      defaultProps: {
        size: 'sm',
      },
      vars: () => ({
        root: {
          '--radio-color': colorToken.color.fg.cloudblue.default.base,
        },
      }),
      classNames: (_, props) => ({
        inner: props.variant === 'outline' ? classes.inner : undefined,
      }),
    }),
  },
}) as MantineTheme;
